import { render } from "./SlideHeroComponent2.vue?vue&type=template&id=cb4ef882"
import script from "./SlideHeroComponent2.vue?vue&type=script&lang=js"
export * from "./SlideHeroComponent2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__